// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"3015349b","136":"fb9c255a"}[chunkId] + ".chunk.js";
};